import axios from "axios";
import {API_HOST} from "../variables";

export const find = async (agentId: string) => {
    return await axios.get(`${API_HOST}/v1/agents/${agentId}/roles`);
}